import { useCallback } from 'react';
import { useSendReadStatusRequest } from '../api/useSendReadStatusRequest';
import { v4 as uuidV4 } from 'uuid';
import { log } from '../lib/logger';
import { useEventStore } from '../stores/eventStore';
export const useSendMessageReadStatus = () => {
    const { events, updateEvents } = useEventStore();
    const sendReadStatusRequest = useSendReadStatusRequest();
    return useCallback((messageId) => {
        const event = events.find(hist => hist.id === messageId);
        if (!event || event.readByCustomer)
            return;
        updateEvents(prevState => prevState.map(ev => {
            if (ev.id === messageId) {
                return Object.assign(Object.assign({}, ev), { readByCustomer: true });
            }
            return ev;
        }));
        if (event.historic)
            return;
        const id = uuidV4();
        const timestamp = Date.now().toString();
        sendReadStatusRequest({ id, timestamp, messageId }).catch(log.error);
    }, [events, sendReadStatusRequest, updateEvents]);
};
